<template>
  <div class="phaseLogin_container">
    <div class="phaseLogin_main">
      <div class="phaseLogin_block">
        <img
          :src="require('@/assets/images/login/logo.png')"
          class="phaseLogin_banner"
        />
        <div class="phaseLogin_btn">
          <div class="phaseLogin_btn_row">
            <span> <span class="date"></span>一期登录入口 </span>
            <CustomButton class="submit-btn" @click="goToLogin(1)">
              点击登录</CustomButton
            >
          </div>
          <div class="phaseLogin_btn_row">
            <span> <span class="date"></span>二期登录入口 </span>
            <CustomButton class="submit-btn" @click="goToLogin(2)">
              点击登录</CustomButton
            >
          </div>
        </div>
        <!-- <img
          class="phaseLogin_tips"
          :src="require('@/assets/images/login/background1.png')"
        />
        <div class="phaseLogin_tips_block">
          <div class="phaseLogin_tips_desc">
            <div class="round"></div>
            8月1日以后的会议请登录三期
          </div>
          <div class="phaseLogin_tips_desc">
            <div class="round"></div>
            8月1日以前的会议请登录二期
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>
<script>
import CustomButton from "@/components/unit/CustomButton";
import { Iphone, Lock } from "@element-plus/icons";
export default {
  name: "login",
  components: {
    CustomButton,
    Iphone,
    Lock,
  },
  data() {
    return {
      loading: false,
    };
  },

  created() {
    document.getElementsByTagName("title")[0].innerHTML = "规范院院行";
    this.$nextTick(() => {
      document.body.addEventListener("contextmenu", this.$tools.noScroll);
    });
  },
  beforeUnMount() {
    document.body.removeEventListener("contextmenu", this.$tools.noScroll);
  },
  methods: {
    imgLoading(event) {
      console.log("图片加载成功", event.target);
      this.loading = true;
    },
    goToLogin(type) {
      let url =
        type == 2
          ? `${this.$config.host2}/#/home`
          : `${this.$config.host1}/#/home`;
      console.log("url :>> ", url);
      window.location.href = url;
    },
  },
};
</script>
<style>
.phaseLogin_container {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  background: linear-gradient(180deg, #fefbfc, #f9d6c9);
  /* background: url("~@/assets/images/login/background.png");
  background-size: 100% 100%; */
}
.phaseLogin_main {
  flex: 1 0 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.phaseLogin_banner {
  width: 10rem;
  object-fit: contain;
  margin-bottom: 0.5rem;
  margin-top: 5rem;
}
.phaseLogin_block {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  /* width: 85%; */

  background: #fff;
  border-radius: 0.8rem;
  padding: 0.1rem;
  position: relative;
}
.phaseLogin_tips {
  width: 100%;
  height: 100%;
  border-radius: 0 0 0.8rem 0.8rem;
}
.phaseLogin_btn {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 3rem 0;
  padding: 0 1.5rem;
}
.submit-btn {
  color: #fff;
  background: #e64638;
  height: 2rem !important;
  font-size: 1rem;
  border-radius: 2rem;
  padding: 0 0.25rem;
  width: 6rem !important;
  /* margin-left: 1.3rem; */

  margin-left: 1rem;
}

.goIcon {
  width: 1rem;
  height: 1rem;
  margin-right: 0.8rem;
}
.phaseLogin_tips_block {
  font-size: 0.8rem;
  color: #8c8c8b;
  position: absolute;
  bottom: 1rem;
}
.phaseLogin_tips_desc {
  display: flex;
  align-items: center;
}
.phaseLogin_tips_desc:last-child {
  margin-top: 0.5rem;
}
.round {
  width: 0.3rem;
  height: 0.3rem;
  border-radius: 50%;
  background: #8c8c8b;
  margin-right: 0.2rem;
}
.phaseLogin_btn_row {
  background: #f2f2f2;
  /* width: 100%; */
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 2rem;
  margin-bottom: 2rem;
  padding: 0.25rem 0.25rem 0.25rem 1.5rem;
  font-size: 1rem;
  white-space: nowrap;
}
.phaseLogin_btn_row .date {
  color: #e64638;
  font-weight: bolder;
  border-bottom: 1px solid #e64638;
}
</style>
